import { render } from "./TheBgRadioForm.vue?vue&type=template&id=381163be"
import script from "./TheBgRadioForm.vue?vue&type=script&lang=js"
export * from "./TheBgRadioForm.vue?vue&type=script&lang=js"
script.render = render

export default script